module.exports = __webpack_public_path__ + "img/choosefile.c52161eb.svg";